import { Component, signal } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NavigationService } from '../../../../../services/navigation.service';
import { SetupWizardState } from '@mira-avant/mtlibs';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
	selector: 'app-setup-wizard-upload-csv-button',
	imports: [NzButtonModule, NzIconModule, NzTooltipModule],
	standalone: true,
	templateUrl: './setup-wizard-upload-csv-button.html',
	styleUrl: './setup-wizard-upload-csv-button.scss',
})
export class SetupWizardUploadCsvButton {
	private sub?: Subscription;
	public clientUuid = signal<string | undefined>(undefined);
	public SetupWizardState = SetupWizardState;

	constructor(
		private route: ActivatedRoute,
		public nav: NavigationService
	) {
		this.sub = this.route.params.subscribe(params => {
			this.clientUuid.set(params['clientUuid']);
		});
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
	}
}
